define([
    'jquery',
    'helpers/console',
    'helpers/matchHeight',
], function($, console, matchHeight) {

    var init = function() {
        $('.series_list__metadata').matchHeight({
            byRow: true,
        });

        $('.series_list__man_wrap').matchHeight({
            byRow: true,
        });
    };

    return {
        init: init
    };
});